<template>
  <div class="editor-item">
    <editor-header
      :item="contentData"
      :title="title"
      :helperReference="contentData.page_block_id"
      :hasHelper="contentData.has_helper"
    >
      <template slot="settings">
        <dropdown-item
          ref="dropdown"
          :class="'editor-item__settings editor-item__button'"
          :class-name="'custom'"
          :isIcon="false"
          :unscroll="'main'"
          :align="'left'"
          :y="27"
          :x="27"
        >
          <template slot="btn">
            <i class="icon-menu-settings"></i>
          </template>
          <template slot="body">
            <div class="dropdown-edit">
              <card-item>
                <ab-select
                  :label="$t('builder.choose_size')"
                  :options="sizeOptions"
                  v-model="contentData.size"
                ></ab-select>
                <ab-select
                    :label="$t('builder.choose_padding')"
                    :options="paddingOptions"
                    v-model="contentData.padding"
                ></ab-select>
                <ab-select
                    :label="$t('builder.choose_valign')"
                    :options="valignOptions"
                    v-model="contentData.valign"
                ></ab-select>

              </card-item>
            </div>
          </template>
        </dropdown-item>
      </template>
    </editor-header>

    <div class="editor-item__content" :class="[isVisible ? '' : 'hide']">
      <card-item v-if="contentData.items.length">
        <draggable-item
          class="grid-x grid-margin-x large-up-2 card-list"
          v-model="contentData.items"
          :group="'subitems' + contentData.id"
          animation="300"
          handle=".sub__drag"
          @start="dragging = true"
          @end="dragFinished"
        >
          <div
            v-for="(item, index) in contentData.items"
            :key="item.number"
            class="cell card background--center card-list__container"
            :dragStatus="dragging"
          >
            <div class="editor-item__sub-item">
              <div class="editor-item__sub-header">
                <div class="grid-x align-right">
                  <div class="cell shrink">
                    <dropdown-item
                      ref="dropdown"
                      :class="'editor-item__settings editor-item__button'"
                      :class-name="'custom'"
                      :isIcon="false"
                      :unscroll="'main'"
                      :align="'left'"
                      :y="27"
                      :x="27"
                    >
                      <template slot="btn">
                        <i class="icon-menu-settings"></i>
                      </template>
                      <template slot="body">
                        <div class="dropdown-edit">
                          <card-item>
                            <ab-select
                              :label="$t('builder.choose_background_type')"
                              :options="typeOptions"
                              v-model="item.type"
                            />

                            <ab-color-picker
                              v-if="item.type === 'color'"
                              :value.sync="item.color"
                              type="large"
                            />
                          </card-item>
                        </div>
                      </template>
                    </dropdown-item>
                    <span class="sub__drag editor-item__button"
                    ><i class="icon-drag-and-drop"
                    /></span>
                  </div>
                </div>
              </div>
              <div
                class="editor-item__sub-content"
                :style="[
                  item.type === 'image'
                    ? {
                        backgroundImage: 'url(' + item.image + ')'
                      }
                    : { backgroundColor: item.color }
                ]"
              >
                <div
                  class="page-banner edit background--center"
                  :class="[contentItem.size]"
                  :style="[
                    typeOptions === 'image'
                      ? {
                          backgroundImage: 'url(' + item.image + ')'
                        }
                      : { backgroundColor: '#' + item.color }
                  ]"
                >
                  <div class="page-banner__content">
                    <div class="grid-x align-middle">
                      <div class="cell content">
                        <content-editor
                          :disabled="dragging"
                          :contentData.sync="item.text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="vue-dropzone-single" v-if="item.type == 'image'">
                    <ab-dropzone :data="item" :id="index" :key="item.number"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </draggable-item>
      </card-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'splitBanner',
  props: {
    index: Number,
    contentItem: Object,
    dragStatus: Boolean
  },
  data () {
    return {
      componentKey: 0,
      isVisible: true,
      sizeOptions: [
        { title: this.$t('app.extra-small'), value: 'card--extra-small' },
        { title: this.$t('app.small'), value: 'card--small' },
        { title: this.$t('app.medium'), value: 'card--medium' },
        { title: this.$t('app.large'), value: 'card--large' },
        { title: this.$t('app.extraLarge'), value: 'card--extra-large' }
      ],
      paddingOptions: [
        { title: this.$t('app.extra-small'), value: 'card--xs-padding' },
        { title: this.$t('app.small'), value: 'card--sm-padding' },
        { title: this.$t('app.medium'), value: 'card--md-padding' },
        { title: this.$t('app.large'), value: 'card--lg-padding' },
        { title: this.$t('app.extraLarge'), value: 'card--xl-padding' }
      ],
      valignOptions: [
        { title: this.$t('builder.valign-top'), value: 'card--valign-top' },
        { title: this.$t('builder.valign-center'), value: 'card--valign-center' },
        { title: this.$t('builder.valign-bottom'), value: 'card--valign-bottom' }
      ],
      typeOptions: [
        { title: this.$t('app.background_color'), value: 'color' },
        { title: this.$t('app.background_image'), value: 'image' }
      ]
    }
  },
  created () {
    if (this.contentData.items.length < 2) {
      this.contentData.items = [{}, {}]
    }
    for (let i = 0; i < this.contentData.items.length; i++) {
      this.contentData.items[i].number = i
    }
  },
  methods: {
    dragFinished () {
      this.dragging = false
      this.componentKey += 1
    },
    deleteItem: function (index) {
      this.componentKey += 1
      this.contentData.items.splice(index, 1)
    }
  },
  computed: {
    contentData: {
      get () {
        return this.contentItem
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    title: function () {
      if (this.contentData._title) {
        return this.contentData._title
      }
      return this.$t('builder.split_banner')
    },
    dragging: {
      get () {
        return this.dragStatus
      },
      set (val) {
        this.$emit('update:dragStatus', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  overflow: visible;
}

.editor-card-sort {
  z-index: 50;
  position: absolute;
  top: 0;
  right: 0;
}

.card__content {
  z-index: 11;
  position: relative;
}

.vue-dropzone {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  .dz-preview {
    height: 100%;
  }
}

.editor-item__sub-content {
  flex-direction: column;
  align-content: center;
}

.page-banner {
  background: none;
  flex-grow: 1;
}

.card-list__container {
  &:nth-child(n + 3) {
    margin-top: 30px;
  }
}

.vue-dropzone-single--absolute {
  left: 0;
}
</style>
